function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "Shape");

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created using Figma");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Canvas",
  transform: "translate(24868 -15859)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Shape"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path0_fill",
  transform: "translate(-24867.4 15860)",
  fill: "#2F80ED"
})));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "path0_fill",
  fillRule: "evenodd",
  d: "M 4.78178 9.05122L 1.19544 5.46489L 0 6.66034L 4.78178 11.4421L 15.0284 1.19544L 13.833 0L 4.78178 9.05122Z"
}));

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/Check.e52db9ec.svg";
export { SvgCheck as ReactComponent };